// extracted by mini-css-extract-plugin
export var image = "SobreMi-module--image--8XLU-";
export var content = "SobreMi-module--content--es9Eg";